// Autogenerated file
export const itemChangePointStatusesEnum = {
    NoVisits: "NoVisits",
    MissingVisit: "MissingVisit",
    Completed: "Completed",
};
export const itemChangePointStatuses = [
    { label: "Перецепка/пересменка", value: "NoVisits" },
    { label: "Перецепка/пересменка", value: "MissingVisit" },
    { label: "Перецепка/пересменка", value: "Completed" },
];
